const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/soh/eCheckin/sections/Versicherung/Blocks/MaternityBlock.tsx';
import { CIS4mBlock } from '@cistec/common_web/modules/CIS4m/components/CIS4mBlock';
import textMap from 'App/config/soh/eCheckin/translations';
import * as React from 'react';
import { forwardRef } from 'react';
import { getInsurancePaths } from '../Versicherung';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import { Link, LinksBlock } from 'App/components/eCheckin/components/fields/LinksBlock';
import { Divider } from '@mui/material';
import { fieldValueIsNot } from 'App/components/eCheckin/utils';
import { GeburtsPaketFields, MaternityPackageCoverage } from '../../components/metakat/Versicherung/GeburtsPaketFields';

type Props = {
    path: string;
    hidden?: boolean;
};

const maternityBrosuresLinks: Link[] = [
    {
        name: 'broschureMaternity',
        text: textMap.broschureMaternity,
        href: 'https://www.solothurnerspitaeler.ch/fileadmin/Broschueren_Flyer/soH/soH_booklet_geburtspackage_A5_2025_web.pdf',
    },
];

export const MaternityBlock = forwardRef((props: Props, ref: any) => {
    const { path } = props;

    const formData = useCIS4mData();
    const hidden = props.hidden ?? false;
    const { PATH_MATERNITY_PACKET, PATH_INSURANCE_COVERAGE } = getInsurancePaths(props.path);

    const isPrivateCoverage = !fieldValueIsNot(formData, PATH_INSURANCE_COVERAGE, ['private']);
    const isGeneralCoverage = !fieldValueIsNot(formData, PATH_INSURANCE_COVERAGE, ['general-Switzerland', 'general']);
    const isSemiPrivateCoverage = !fieldValueIsNot(formData, PATH_INSURANCE_COVERAGE, ['semi-private']);

    const maternityBlockRef = useCIS4m(ref);

    const coverage = ((): MaternityPackageCoverage | undefined => {
        if (isGeneralCoverage) {
            return 'allgemein';
        } else if (isSemiPrivateCoverage) {
            return 'halbPrivat';
        } else if (isPrivateCoverage) {
            return 'privat';
        }
    })();

    return (
        <CIS4mBlock ref={maternityBlockRef} hidden={hidden}>
            <GeburtsPaketFields label={textMap.maternityPacket} coverage={coverage} path={PATH_MATERNITY_PACKET} />
            <Divider />
            <LinksBlock links={maternityBrosuresLinks} basePath={path} hideCheckbox={true} />
        </CIS4mBlock>
    );
});

MaternityBlock.displayName = 'MaternityBlock';
